import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/styles';
import {Grid, Typography, Link} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRigt: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    logo: {
        width: '200px',
        display: 'block'
    }
}));

const Footer = props => {
    const {className, ...rest} = props;

    const classes = useStyles();

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
                spacing={2}
            >
                <Grid
                    item
                >
                    <RouterLink to="/">
                        <img
                            alt="ECDI"
                            className={classes.logo}
                            src="/images/logos/ecbi_logo.png"
                        />
                    </RouterLink>
                </Grid>
                <Grid
                    item
                >
                    <Typography variant="body2">
                        <Link
                            component="a"
                            href="https://www.ecbi.co.kr/"
                            target="_blank"
                        >
                            www.ecbi.co.kr
                        </Link><br />
                        4-5F Innsbruck 10, Bongeunsa-ro 26-gil, Gangnam-gu, Seoul, Republic of Korea 06125<br />
                        Copyright ⓒ 2021 INNSBRUCK All rights reserved.
                    </Typography>
                </Grid>
            </Grid>
        </div>
    );
};

Footer.propTypes = {
    className: PropTypes.string
};

export default Footer;
